import { render, staticRenderFns } from "./spatialUpdatingIcon.vue?vue&type=template&id=1343d566&"
import script from "./spatialUpdatingIcon.vue?vue&type=script&lang=js&"
export * from "./spatialUpdatingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports